import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Support({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M9.9716 9.98641H8.48898C8.48898 9.02566 8.7052 8.79018 9.1994 8.41342C9.33081 8.3014 9.47347 8.20999 9.60981 8.12263C9.94351 7.90881 10.2393 7.71929 10.2393 7.31138C10.2393 6.86868 9.85835 6.60494 9.36414 6.60494C8.74638 6.60494 8.32424 6.97229 8.32424 7.57511H6.66659C6.69747 6.24701 7.71678 5.33335 9.43621 5.33335C10.9703 5.33335 11.9999 6.11514 11.9999 7.25486C11.9999 8.14026 11.4851 8.50761 11.0321 8.78076C10.9425 8.83343 10.8601 8.88084 10.7841 8.92451C10.4932 9.09172 10.2978 9.20401 10.1672 9.34591C10.0231 9.51546 9.9716 9.685 9.9716 9.98641Z"
        fill={iconColor}
      />
      <Path
        d="M10.0849 12.1905H8.32424V10.6081H10.0849V12.1905Z"
        fill={iconColor}
      />
      <Path
        d="M1.33325 3.33335C1.33325 2.96516 1.63173 2.66669 1.99992 2.66669H16.6666C17.0348 2.66669 17.3333 2.96516 17.3333 3.33335V14C17.3333 14.3682 17.0348 14.6667 16.6666 14.6667H10.2761L6.47132 18.4714C6.28066 18.6621 5.99391 18.7191 5.7448 18.6159C5.49568 18.5128 5.33325 18.2697 5.33325 18V14.6667H1.99992C1.63173 14.6667 1.33325 14.3682 1.33325 14V3.33335ZM2.66659 4.00002V13.3334H5.99992C6.36811 13.3334 6.66659 13.6318 6.66659 14V16.3905L9.52851 13.5286C9.65354 13.4036 9.82311 13.3334 9.99992 13.3334H15.9999V4.00002H2.66659Z"
        fill={iconColor}
      />
      <Path
        d="M18.6666 7.33335H21.3333V16.6667H15.9999C15.6317 16.6667 15.3333 16.9652 15.3333 17.3334V19.0572L13.138 16.8619C13.013 16.7369 12.8434 16.6667 12.6666 16.6667H10.1617L8.82835 18H12.3904L15.5285 21.1381C15.7192 21.3288 16.0059 21.3858 16.255 21.2826C16.5042 21.1794 16.6666 20.9363 16.6666 20.6667V18H21.9999C22.3681 18 22.6666 17.7015 22.6666 17.3334V6.66669C22.6666 6.2985 22.3681 6.00002 21.9999 6.00002H18.6666V7.33335Z"
        fill={iconColor}
      />
    </Svg>
  );
}
